<template>
  <div class="info_car_hour">
    <div class="hour_box">
      <div class="img_box" v-for="(item, index) in HonorList" :key="index">
        <el-image style="width: 100%; height: 100%;position: relative" :src="item.image" fit="contain"
          :preview-src-list="srcList">
        </el-image>
        <img src="../../assets/AboutImg/img_fangda.png" class="incos">
      </div>
    </div>
    <div class="block_pagination block_pc" v-if="total">
      <el-pagination background @current-change="handleCurrentChange" :current-page="page" :page-size="10"
        :pager-count="7" layout="prev, pager, next, total,jumper" :total="total">
      </el-pagination>
    </div>
    <div class="block_pagination block_wap" v-if="total">
      <el-pagination background @current-change="handleCurrentChange" :current-page="page" :page-size="10"
        :pager-count="5" layout="prev, pager, next" :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getHonor } from "../../api/apis";

export default {
  name: "qualification",
  data() {
    return {
      HonorList: [],
      page: 1,
      total: 0,
      srcList: []
    }
  },
  methods: {
    handleCurrentChange(e) {
      this.page = e
      this.GetHonor()
    },
    GetHonor() {
      let datas = { page: this.page, limit: 6 }
      getHonor(datas).then(res => {
        res.data.data.map(item => {
          this.srcList.push(item.image)
        })
        this.HonorList = res.data.data
        this.total = res.data.total
      })
    }
  },
  mounted() {
    this.GetHonor()
  }
}
</script>

<style scoped lang="less">
.info_car_hour {
  margin-top: 68px;

  .hour_box {
    width: 1200px;
    display: flex;
    margin: 0 auto 60px;
    flex-wrap: wrap;

    .img_box {
      width: 378px;
      height: 476px;
      margin-right: 33px;
      margin-bottom: 40px;
      overflow: hidden;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

      .incos {
        width: 20px;
        height: 20px;
        position: absolute;
        bottom: 25px;
        right: 35px;
        opacity: 0;
      }
    }

    .img_box:nth-child(3n) {
      margin-right: 0;
    }

    .img_box:hover .incos {
      opacity: 1;
      transition: all 0.3s linear;
    }
  }

  .block_wap {
    display: none;
  }

  .block_pc {
    display: block;
    margin: 0 auto 217px;
  }
}

@media screen and (min-width:414px) and (max-width:1200px) {
  .info_car_hour .hour_box {
    justify-content: center;
  }
}

@media (max-width: 1200px) {
  .info_car_hour {
    margin-top: 20px;

    .hour_box {
      width: auto;
      padding: 0 15px;
      display: flex;
      margin: 0 auto 35px;
      flex-wrap: wrap;
      justify-content: space-between;

      .img_box {
        width: 165px;
        height: 208px;
        margin-right: 0;
        margin-bottom: 15px;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .img_box:nth-child(3n) {
        margin-right: 0;
      }
    }

    .block_wap {
      display: block;
      margin: 0 auto 70px;
    }

    .block_pc {
      display: none;
    }
  }
}
</style>